import React from 'react';
import propTypes from './propTypes';

const SoilSamplingTasks = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M3 13C1.89543 13 1 13.8954 1 15V23H23V15C23 13.8954 22.1046 13 21 13H18.7808C17.8547 13 17.1448 13.614 16.8179 14.2904C16.3693 15.2189 15.1396 17 12 17C8.86039 17 7.63068 15.2189 7.18208 14.2904C6.85523 13.614 6.14526 13 5.21922 13H3ZM3 21V15H5.21925C5.21925 15 5.22277 15 5.22997 15.0024C5.23796 15.0051 5.25184 15.0112 5.26998 15.0241C5.30878 15.0515 5.35156 15.0991 5.38128 15.1606C6.04685 16.538 7.85681 19 12 19C16.1432 19 17.9531 16.538 18.6187 15.1606C18.6484 15.0991 18.6912 15.0515 18.73 15.0241C18.7482 15.0112 18.762 15.0051 18.77 15.0024C18.7772 15 18.7808 15 18.7808 15H21V21H3Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M9.5 1H14.5V3H13V7H15.5V11.5C15.5 13.433 13.933 15 12 15C10.067 15 8.5 13.433 8.5 11.5V7H11V3H9.5V1ZM10.5 11.5V9H11V9.5C11 10.0523 11.4477 10.5 12 10.5C12.5523 10.5 13 10.0523 13 9.5V9H13.5V11.5C13.5 12.3284 12.8284 13 12 13C11.1716 13 10.5 12.3284 10.5 11.5Z" fill="currentColor" />
  </svg>
);

SoilSamplingTasks.propTypes = propTypes;

export default SoilSamplingTasks;
